/**
 * Logger utility that only enables console logs in development mode
 * This helps prevent logs from appearing in production environments
 */

type LogLevel = "log" | "info" | "warn" | "error" | "debug" | "stage";

const isDevelopment = import.meta.env.VITE_NODE_ENV === "development";
const isStaging = import.meta.env.VITE_NODE_ENV === "staging";

const createLogger = () => {
  const logger: Record<LogLevel, (...args: any[]) => void> = {
    log: (...args: any[]) => {
      if (isDevelopment) {
        console.log(...args);
      }
    },
    stage: (...args: any[]) => {
      if (isStaging) {
        console.log(...args);
      }
    },
    info: (...args: any[]) => {
      if (isDevelopment) {
        console.info(...args);
      }
    },
    warn: (...args: any[]) => {
      if (isDevelopment) {
        console.warn(...args);
      }
    },
    error: (...args: any[]) => {
      console.error(...args);
    },
    debug: (...args: any[]) => {
      if (isDevelopment) {
        console.debug(...args);
      }
    },
  };

  return logger;
};

const logger = createLogger();

export default logger;
